import React, { Component } from 'react';
import { Row, Col, Input, Modal } from 'antd';

const { TextArea } = Input;

class EditDepartment extends Component {

    constructor( props ){
        super( props );

        this.state = {
            visible: false,
            name: 'none',
            email: '',
            id: ''
        }

        this.handleOk = this.handleOk.bind( this );
        this.handleCancel = this.handleCancel.bind( this );    
    }

    handleOk = (e) => {

        if( this.state.name === "" || this.state.name === "none" ){

            this.setState({
                name: ''
            })


            return false;
        }

        this.props.onSubmit( this.state );

        this.setState({ visible: false });
    
    }

    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    }

    componentWillReceiveProps( nextProps ){
        this.setState({
            visible: nextProps.onModel,
            id: nextProps.data.department_id,
            name: nextProps.data.department_name,
            email: nextProps.data.department_email
        })
    }


    render() {
        return (
            <Modal
                title="Edit Department"
                maskClosable={ false }
                visible={this.state.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                >
                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label  className={ ( this.state.name === '') ? 'error': '' }>Department Name</label>
                        <Input 
                            value={ this.state.name }
                            className={ ( this.state.name === '') ? 'br_error': '' } onChange={ (e)=> this.setState({ name: e.target.value }) } size="default"  />
                    </Col>
                </Row>
                <Row className="mrg_b_10">
                    <Col span={24}>
                        <label>Mail Alias</label>
                        <Input 
                            value={ this.state.email }
                            onChange={ (e)=> this.setState({ email: e.target.value }) } size="default"  />
                    </Col>
                </Row>
            </Modal>
        )
    }
}

export default EditDepartment


                    
                


// WEBPACK FOOTER //
// ./src/pages/department/childs/edit.department.js